// src/lib/richtext/tiptapExtensions.js
// Shared TipTap extension list. Used by the editor, the JSON->HTML converter,
// and anywhere else we need a TipTap schema. Keep this list authoritative —
// if the editor and converter drift, marks/nodes silently disappear on render.
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import Underline from '@tiptap/extension-underline'
import { TextStyle } from '@tiptap/extension-text-style'
import { Color } from '@tiptap/extension-color'
import { Highlight } from '@tiptap/extension-highlight'
import TextAlign from '@tiptap/extension-text-align'
import Typography from '@tiptap/extension-typography'
import Placeholder from '@tiptap/extension-placeholder'
import CharacterCount from '@tiptap/extension-character-count'
import Image from '@tiptap/extension-image'
import { normalizeRichTextUrl } from './htmlSanitizer'

export const buildRichTextExtensions = ({
  placeholder,
  characterLimit,
  withImage = true,
  extra = [],
} = {}) => [
  StarterKit.configure({
    bulletList: { keepMarks: true },
    orderedList: { keepMarks: true },
    heading: { levels: [1, 2, 3] },
    link: false,
    underline: false,
  }),
  Link.configure({
    openOnClick: false,
    autolink: true,
    linkOnPaste: true,
    protocols: ['http', 'https', 'mailto', 'tel'],
    isAllowedUri: (url) => Boolean(normalizeRichTextUrl(url)),
    HTMLAttributes: {
      rel: 'noopener noreferrer nofollow',
      target: '_blank',
    },
  }),
  Underline,
  Typography,
  TextStyle,
  Color,
  Highlight.configure({ multicolor: true }),
  TextAlign.configure({ types: ['heading', 'paragraph'] }),
  ...(placeholder ? [Placeholder.configure({
    placeholder,
    showOnlyWhenEditable: true,
    showOnlyCurrent: false,
    includeChildren: false,
  })] : []),
  ...(characterLimit ? [CharacterCount.configure({ limit: characterLimit })] : [CharacterCount]),
  ...(withImage ? [Image.configure({ inline: false, allowBase64: true, HTMLAttributes: { loading: 'lazy' } })] : []),
  ...extra,
]

export const richTextExtensions = buildRichTextExtensions()
